import { createStore as createZustandStore } from 'zustand';
import { devtools, subscribeWithSelector } from 'zustand/middleware';
export * from 'zustand';
export const createStore = (initializer, options = {}) => {
  const store = createZustandStore()(devtools(subscribeWithSelector(initializer), options.devtools));
  return store;
};